import React, { Component } from 'react'
import { Button, InputNumber } from 'hljd'
import { inject, observer } from 'mobx-react'
import Style from './style.module.less'

@inject('store')
@observer
export default class extends Component {
  render() {
    const { store } = this.props
    const { videoSeek, changeVideoSeek, submitVideoSeek } = store
    const { startHour, startMin, startSec, endHour, endMin, endSec } = videoSeek

    const secondParams = {
      max: 59,
      min: 0,
      step: 1,
      precision: 0
    }

    return (
      <div className={Style.timeInput}>
        <p className={Style.desc}>
          直播裁剪：支持截取视频中间部分内容对用户展示，截取成功后仅在用户端更新，商家中心保留完整视频。
        </p>
        视频时间&nbsp; : &nbsp;
        <InputNumber
          value={startHour}
          {...secondParams}
          onChange={changeVideoSeek('startHour')}
        />
        &nbsp; : &nbsp;
        <InputNumber
          {...secondParams}
          value={startMin}
          onChange={changeVideoSeek('startMin')}
        />
        &nbsp; : &nbsp;
        <InputNumber
          {...secondParams}
          value={startSec}
          onChange={changeVideoSeek('startSec')}
        />
        &nbsp; ~ &nbsp;
        <InputNumber
          {...secondParams}
          value={endHour}
          onChange={changeVideoSeek('endHour')}
        />
        &nbsp; : &nbsp;
        <InputNumber
          {...secondParams}
          value={endMin}
          onChange={changeVideoSeek('endMin')}
        />
        &nbsp; : &nbsp;
        <InputNumber
          {...secondParams}
          value={endSec}
          onChange={changeVideoSeek('endSec')}
        />
        <Button type="primary" onClick={submitVideoSeek}>
          保存修改
        </Button>
      </div>
    )
  }
}
